import React, { type ReactNode } from "react";

/**
 * AppLayout is now a pass-through wrapper because the actual
 * sidebar and topbar are handled by WorkspaceShell (True MDI).
 */
export default function AppLayout({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
